"use client"

import { useQuery } from "@tanstack/react-query"
import {
  getAgentModelOverrideAction,
  type AgentModelOverrideView,
} from "@/server-actions/ai-agent-model-config"
import type { AgentOverrideScopeType } from "@/lib/ai/use-cases"

export const agentModelOverrideQueryKey = (scopeType: string, scopeId: string) =>
  ["ai-agent-model-override", scopeType, scopeId] as const

export function useAgentModelOverrideQuery(
  scopeType: AgentOverrideScopeType,
  scopeId: string,
  enabled = true,
) {
  return useQuery<AgentModelOverrideView>({
    queryKey: agentModelOverrideQueryKey(scopeType, scopeId),
    enabled: enabled && !!scopeId,
    queryFn: async () => {
      const result = await getAgentModelOverrideAction({ scope_type: scopeType, scope_id: scopeId })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
